import React from 'react';
import ToJoin from './toJoin';

async function action({query, cookie, fetch }) {
    return {
        title: '东楚优房',
        chunks: ['toJoin'],
        keywords: '东楚优房',
        description: '东楚优房',
        component: (
            <ToJoin  />
        )
    };
}


export default action;
